
import { defineComponent } from "vue";
import { Component } from "@/utils/components/Component";
import ComponentList from "@/components/ComponentList.vue";

import { registerComponent } from "@/utils/manager/ComponentManager";
import {
  componentTree,
  copiedComponent,
  pasteComponent,
  selection,
  updateSelection
} from "../utils/manager/WorkspaceManager";
import { componentInfo, componentNames } from "../utils/ComponentMeta";
import { vueRef } from "../utils/VueRef";

export default defineComponent({
  components: { ComponentList },

  data() {
    return {
      componentInfo,
      componentNames,
      componentTree: vueRef(componentTree),
      selection: vueRef(selection),
      copiedComponent: vueRef(copiedComponent),
      updateSelection,
      pasteComponent,
      addComponentAnchor: null as null | Component[]
    };
  },

  mounted() {
    document.addEventListener("click", this.checkClose, { capture: true });
  },

  unmounted() {
    document.removeEventListener("click", this.checkClose, { capture: true });
  },

  computed: {
    selectedComponent(): Component | null {
      return this.selection?.component || null;
    }
  },

  methods: {
    checkDelete(component: Component) {
      if (this.selection?.component?.id == component.id) {
        this.updateSelection({ value: null });
      }
    },

    checkClose(ev: MouseEvent) {
      const menuComp = this.$refs.compAddMenu as HTMLElement;
      if (ev.target != menuComp) menuComp.style.display = "none";
    },

    addChildToTreeElem(data: { event: MouseEvent; anchor: Component[] }) {
      this.showCompAddMenu(data.event, data.anchor);
    },

    addNewCompoenent(key: string) {
      const nComp = componentInfo[key].generator();
      registerComponent(nComp);

      this.addComponentAnchor!.splice(0, 0, nComp);
      this.updateSelection({ value: nComp });
      const menu = this.$refs.compAddMenu as HTMLElement;
      menu.style.display = "none";
    },

    showCompAddMenu(
      ev: MouseEvent,
      anchor = undefined as undefined | Component[]
    ) {
      const menu = this.$refs.compAddMenu as HTMLElement;
      menu.style.display = "block";
      menu.style.opacity = "0";
      this.addComponentAnchor = anchor || this.componentTree;

      setTimeout(() => {
        let y = ev.y;

        if (y + menu.offsetHeight > window.innerHeight)
          y = ev.y - menu.offsetHeight - 5;

        menu.style.opacity = "1";
        menu.style.top = y + "px";
        menu.style.left = ev.x + "px";
      }, 3);
    }
  }
});
